import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { ImageBase } from '@/components/ui/Image/ImageBase';
import { propArrayShape, propBool, propFunc, propShape, propStr, } from '../../../../helpers/custom-prop-types';
import CustomSlider from '../../../Ui/Slider';
import FavoriteColumnBox from '../../Common/FavoriteColumnBox';
import ShareList from '../../Common/ShareList';
import LeftComponentForGuest from './LeftComponentForGuest';
import LeftComponentForMember from './LeftComponentForMember';
const LeftComponent = (props) => {
    const { contents, document, hasFavorite, isClientUser, isGuestUser, loadingFavorite, onClickCopy, onCreateFavorite, onDeleteFavorite, title, } = props;
    const { id, shortUrl, thumbnails } = document;
    const config = useMemo(() => ({
        adaptiveHeight: false,
        arrows: true,
        dots: true,
        infinite: true,
        slidesToShow: 1,
    }), []);
    return (_jsxs("div", Object.assign({ className: 'document_left_column' }, { children: [thumbnails.length > 0 && (_jsx("div", Object.assign({ className: 'document_one_images' }, { children: _jsx(CustomSlider, Object.assign({ className: '', config: config }, { children: thumbnails.map((thumbnail) => {
                        var _a, _b, _c, _d;
                        return (_jsx("div", Object.assign({ className: 'image_box' }, { children: _jsx(ImageBase, { alt: title, objectPosition: 'cover', src: ((_a = thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.default) === null || _a === void 0 ? void 0 : _a.src) || '', webpSrc: (_b = thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.webp) === null || _b === void 0 ? void 0 : _b.src }) }), ((_c = thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.webp) === null || _c === void 0 ? void 0 : _c.src) || ((_d = thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.default) === null || _d === void 0 ? void 0 : _d.src)));
                    }) })) }))), _jsxs("div", Object.assign({ className: 'document_one_share' }, { children: [_jsx(ShareList, { onClickClip: onClickCopy, shareUrl: shortUrl, suffix: 'Proffit', title: title }), isClientUser && (_jsx(FavoriteColumnBox, { hasFavorite: hasFavorite, loadingFavorite: loadingFavorite, onCreateFavorite: onCreateFavorite, onDeleteFavorite: onDeleteFavorite, value: id }))] })), isGuestUser ? (_jsx(LeftComponentForGuest, { contents: contents, document: document })) : (_jsx(LeftComponentForMember, { document: document }))] })));
};
LeftComponent.propTypes = {
    contents: propArrayShape().isRequired,
    document: propShape().isRequired,
    hasFavorite: propBool().isRequired,
    isClientUser: propBool().isRequired,
    isGuestUser: propBool().isRequired,
    loadingFavorite: propBool().isRequired,
    onClickCopy: propFunc().isRequired,
    onCreateFavorite: propFunc().isRequired,
    onDeleteFavorite: propFunc().isRequired,
    title: propStr().isRequired,
};
export default LeftComponent;
